type Client = {
  clientId: number;
  clientName: string;
  costCenterName: string;
  sum: number;
}

type Document = {
  bucket: 'pretension';
  objectName: string;
  type: 'pretension' | 'attachment';
}

export type PretensionType = 'damage' | 'fine' | '';

export interface Pretension {
  id: number;
  sequence: string;
  type: PretensionType;
  dateFrom: string;
  dateTo: string;
  postDate: string;
  platfromName: string;
  supplierLegalName: string;
  status: PretensionStatus;
  clients: Client[];
  documents: Document[];
  typeName?: string;
}

export enum PretensionStatus {
  CREATED = 'created',
  SIGNER_SIGNING_AWAIT = 'signer_signing_await',
  SUPPLIER_SIGNING_AWAIT = 'supplier_approve_await',
  ACCOUNTING_APPROVE_AWAIT = 'accounting_approve_await',
  PAYMENT_AWAIT = 'payment_await',
  PAYMENT_DONE = 'payment_done',
  RECALLED = 'recalled',
}
